import React from "react";
import { Create, SimpleForm } from 'react-admin';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';
import { DeveloperForm } from '../forms/DeveloperForm';


export const DeveloperCreate = (props) => (
	<Create {...props}>
		<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />} redirect="list">
			<DeveloperForm isCreate />
		</SimpleForm>
	</Create>
);
